import anime from '../libs/anime'
import globalVar from '../utils/globalVar'

class Module20Sustain {
  constructor() {
    let cache = {};
    let initFunc = () => {
      initCache();
      registerEvents();
    }

    let initCache = () => {
      cache.cards = document.querySelectorAll('.module-20_sustain .card_sustain');
    };

    let registerEvents = () => {
        for (let i = 0; i < cache.cards.length; i++) {
            cache.cards[i].addEventListener('click',switchContent);
        }
    };

    let switchContent = function() {
       const parent = this.closest('.sustain_container');
       const content = parent.querySelectorAll('.content_container .sustain_content');
       const curentCard = parent.querySelector('.card_sustain.active');
       const currentIndex = parseInt(curentCard.dataset.index);
       const currentContent = content[currentIndex];

       const targetCard = this;
       const targetIndex = parseInt(targetCard.dataset.index);
       const targetContent = content[targetIndex];

       curentCard.classList.remove('active');
       targetCard.classList.add('active');

       targetContent.style.display = "block";
       targetContent.style.height = "auto";
       const height = targetContent.offsetHeight;
       targetContent.style.height = 0;

       anime({
            targets: currentContent,
            duration: 400,
            opacity: [1, 0],
            height: [currentContent.offsetHeight, 0],
            easing: 'easeInOutCubic',
            complete: function() {
                currentContent.style.display = "none";
                anime({
                    targets: targetContent,
                    duration: 400,
                    opacity: [0,1],
                    height: [0, height],
                    easing: 'easeInOutCubic',
                });
            }
        });

    }

    initFunc();
  };
}
export { Module20Sustain }